"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FlexSpace;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const Wrapper = styled_components_1.styled.div `
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  margin: ${(props) => props.extra && props.theme.gutter};
  flex: 0 0 auto;
`;
/** A blank element for spacing, with a fixed flex size */
function FlexSpace({ size, extra }) {
    try {
        const theme = (0, styled_components_1.useTheme)();
        if (!size)
            size = theme.spacing;
        else if (typeof size === "number")
            size = `${size}px`;
        else if (Object.keys(theme).includes(size))
            // @ts-ignore
            size = theme[size];
    }
    catch (_) {
        // Errors getting theme, e.g. in unit test environment
        size = "10px";
    }
    return react_1.default.createElement(Wrapper, { size: size, extra: extra });
}
//# sourceMappingURL=FlexSpace.js.map